import React from "react";
import { Link } from "react-router-dom";
import {
    Collapse,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
} from "@mui/material";

import ThisTheme from "../../../themes/X360Theme";

import DashboardIcon from "@mui/icons-material/Dashboard";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const X360Menu = () => {
    const [open, setOpen] = React.useState(false);
    const handleClick = () => {
        setOpen(!open);
    };

    const menuItems = [
        {
            path: "/x360",
            label: "Dashboard",
            icon: (
                <DashboardIcon sx={{ color: ThisTheme.palette.primary.main }} />
            ),
        },
    ];

    return (
        <List
            component="nav"
            className="menu-list"
            aria-label="Doctor 360&deg; menu"
            data-cy="menu_x360"
        >
            <ListItem
                component="div"
                onClick={handleClick}
                aria-expanded={open}
                disablePadding
            >
                <ListItemButton>
                    <ListItemIcon>
                        <AssessmentOutlinedIcon
                            sx={{ color: ThisTheme.palette.primary.main }}
                        />
                    </ListItemIcon>
                    <ListItemText primary="Doctor 360&deg;" />
                    {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </ListItemButton>
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="nav" disablePadding>
                    {menuItems &&
                        menuItems.length &&
                        menuItems.map(({ path, icon, label }) => (
                            <ListItem
                                key={path}
                                component={Link}
                                to={path}
                                disablePadding
                            >
                                <ListItemButton className="nested">
                                    <ListItemIcon>{icon}</ListItemIcon>
                                    <ListItemText>{label}</ListItemText>
                                </ListItemButton>
                            </ListItem>
                        ))}
                </List>
            </Collapse>
        </List>
    );
};

export default X360Menu;
